import React, {useEffect, useState} from 'react';
import {InfoBanner} from "../../ui/InfoBanner";
import {makeStyles} from "@mui/styles";
import {AppButton} from "../../ui/AppButton";
import {pathParams} from "path-params";
import {Routes} from "../../../constants/Routes";
import {useHistory, useParams} from "react-router";
import {useIntegrationsContext} from "../../../api/integrations/IntegrationsContext";
import {showError} from "../../../utils/NotificationUtils";
import {GetIntegrationTriggerListProps} from "../../../api/integrations/IntegrationsDTO";
import {Loader} from "../../ui/Loader";
import {IntegrationEventsList} from "../IntegrationEventsList";

const useStyles = makeStyles(() => ({
    root: {
        padding: 40,
    },
    container: {
        maxWidth: 1100,
        margin: "0 auto"
    }
}));

export function IntegrationTriggersListRoot() {
    const classes = useStyles();
    const params: any = useParams();
    const history = useHistory();
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState<GetIntegrationTriggerListProps[]>([]);
    const {IntegrationsApi} = useIntegrationsContext();

    useEffect(() => {
        IntegrationsApi.getIntegrationTriggersList({params: {integrationId: params.id}}).then(res => {
            setData(res.payload.list);
            setLoading(false)
        }).catch(err => {
            setLoading(false);
            showError(err)
        })
    }, [IntegrationsApi, params]);
    return (
        <div className={classes.root}>
            {loading ? <Loader/> : (
                <div className={classes.container}>
                    <div>
                        <h3>Triggers</h3>
                    </div>
                    {data.length === 0 ? <InfoBanner title="Add Your First Trigger"
                                                     description="Triggers GET or read data from your API
                                                 to start workflows. Add triggers for new and updated
                                                 items in your app so users can use the data in other apps"/> : (
                        <IntegrationEventsList isTrigger={true} data={data}/>
                    )}
                    <AppButton size="large"
                               sx={{mt: 2}}
                               onClick={() => history.push(pathParams(Routes.IntegrationEditorTriggerAdd, {id: params.id}))}>Add
                        Trigger</AppButton>
                </div>
            )}
        </div>
    );
}

